import { RectangularCoordinates } from '@shure/shared/angular/data-access/system-api/core';
import { getCenterPoint, getDimensions, Point, PositionUnit } from '@shure/shared/angular/utils/utils-position';

import { CoverageAreaRect } from '../../api/models';

export class SysApiCoverageAreaRectMapper {
	/** Map system api `RectangularCoordinates` to `CoverageAreaRect` */
	public static toCoverageAreaRect(coordinates?: RectangularCoordinates): CoverageAreaRect {
		const pointA: Point = { x: coordinates?.xMax ?? 0, y: coordinates?.yMax ?? 0 };
		const pointB: Point = { x: coordinates?.xMin ?? 0, y: coordinates?.yMin ?? 0 };

		const { x, y } = getCenterPoint(pointA, pointB);
		const { height, width } = getDimensions(pointA, pointB);

		return {
			x: PositionUnit.fromRaw(x),
			y: PositionUnit.fromRaw(y),
			height: PositionUnit.fromRaw(height),
			width: PositionUnit.fromRaw(width)
		};
	}

	/** Map `CoverageAreaRect` to system api `RectangularCoordinates` */
	public static toCoverageAreaCoordinates(area: CoverageAreaRect): RectangularCoordinates {
		return {
			xMax: area.x.rawValue + area.width.rawValue / 2,
			xMin: area.x.rawValue - area.width.rawValue / 2,
			yMax: area.y.rawValue + area.height.rawValue / 2,
			yMin: area.y.rawValue - area.height.rawValue / 2
		};
	}
}
